<template>
  <div class="option-btn-box">
    <van-row class="txt-center">
      <van-col :span="6">
        <div style="height: 40px; padding-top: 5px" @click="show = true">
          <p style="line-height: 1.5">
            {{ $t("trade.num") }}<van-icon name="arrow-down" />
          </p>
          <span>{{ num ? num : "-" }}</span>
        </div>
      </van-col>
      <van-col :span="6">
        <div style="height: 40px; padding-top: 5px" @click="show = true">
          <p style="line-height: 1.5">
            {{ $t("option.time") }}<van-icon name="arrow-down" />
          </p>
          <span>{{ time ? time + "s" : "-" }}</span>
        </div>
      </van-col>
      <van-col :span="6">
        <van-button style="width: 90%" class="web-btn-rise" @click="toBuy()">{{
          $t("common.buyup")
        }}</van-button>
      </van-col>
      <van-col :span="6">
        <van-button style="width: 90%" class="web-btn-fail" @click="toSell()">{{
          $t("common.buydown")
        }}</van-button>
      </van-col>
    </van-row>
    <van-popup v-model="show" position="bottom" round>
      <div class="option-btn-box-setting">
        <div class="title">{{ $t("option.transaction") }}</div>
        <div>
          <p class="currency selectitem">{{ unit }}</p>
        </div>
        <div class="title">{{ $t("option.quantity") }}</div>
        <div>
          <ul>
            <li
              @click="num = item"
              class="selectitem"
              :class="item == num ? 'currency' : ''"
              v-for="item in numcols"
              :key="item"
            >
              {{ item }}
            </li>
          </ul>
          <div>
            <van-field
              class="tmp"
              v-model="num"
              type="number"
              center
              clearable
              :placeholder="$t('option.quantityerror')"
            >
              <template #button>
                <span class="link-btn" @click="num = balance">{{
                  $t("common.all")
                }}</span>
              </template>
            </van-field>
          </div>
        </div>
        <div class="title">{{ $t("option.times") }}</div>
        <div>
          <ul>
            <li
              @click="changeTime(index)"
              class="selectitem1"
              :class="item == time ? 'currency' : ''"
              v-for="(item, index) in timecols"
              :key="index"
            >
              {{ item }}s
            </li>
          </ul>
        </div>
        <div style="clear: both">
          <div style="line-height: 30px;float: left;max-width: 60%;" class="data-up">
            {{ $t("option.account") }} :
            {{ balance ? parseFloat(balance).toFixed(8) : "0.00" }}
          </div>
          <div style="float: right;max-width: 40%;line-height: 30px;" class="data-up">
            {{ $t('lockming.estimation') }} :
            {{ hy_ykblval ? parseFloat(hy_ykblval).toFixed(0) : "0" }}%
          </div>
          <div style="float: left;line-height: 30px;width: 100%;margin-bottom: 10px;" class="data-up">
            {{ $t("option.quantity") }} :
            {{ numcols ? numcols[0]:0 }} - {{ numcols ? numcols[numcols.length - 1]:0 }}
          </div>
        </div>
        <div style="padding: 10px">
          <van-row>
            <van-col :span="12">
              <van-button
                style="width: 90%"
                class="web-btn-rise"
                @click="toBuy"
                >{{ $t("common.buyup") }}</van-button
              >
            </van-col>
            <van-col :span="12" class="txt-right">
              <van-button style="width: 90%" class="web-btn-fail" @click="toSell">{{
                $t("common.buydown")
              }}</van-button>
            </van-col>
          </van-row>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showorderconfirm" position="bottom" round closeable>
      <OrderConfirm
        ref="OrderConfirm"
        @close-order="showorderconfirm = false"
        :order_id="order_id"
      />
    </van-popup>
    <van-dialog
      v-model="showconfirm"
      :title="title"
      show-cancel-button
      :confirmButtonText="$t('common.confirm')"
      :cancelButtonText="$t('common.cancel')"
      @confirm="onSubmit()"
    >
      <div style="padding: 10px 30px">
        <p style="margin-bottom: 20px">
          {{ $t("option.quantity") }}: {{ num }}
        </p>
        <p style="margin-bottom: 20px">{{ $t("option.times") }}: {{ time }}s</p>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import OrderConfirm from "./confirmorder.vue";
export default {
  name: "OperationBtns",
  props: ["symbol"],
  inject: ["app"],
  computed: {
    safeWapConfig() {
      return this.app.wapConfig || {};
    },

    safeSymbol() {
      return this.symbol || {};
    },
  },
  watch: {
    symbol() {},
  },
  components: { OrderConfirm },
  data() {
    return {
      hy_ykbl:[],
      hy_ykblval: null,
      hy_price_type:2,
      unit: null,
      show: false,
      showconfirm: false,
      showorderconfirm: false,
      numcolstmp: [1, 3, 5, 10],
      hymin: null,
      numcols: [],
      num: null,
      timecols: [],
      time: null,
      title: null,
      balance: null,
      frm: {
        m_id: null, //	是	int	市场id
        ctime: null, //	是	int	选择的交易时间
        ctzed: null, //	是	int	下注额度
        buytype: null, //
      },
      order_id: null
    };
  },
  mounted() {
    this.getHyConfig();
  },
  methods: {
    toBuy() {
      if (this.num && this.time) {
        this.frm.buytype = 1;
        this.show = false;
        this.showconfirm = true;
        this.title = this.$t("common.buyup");
      } else this.show = true;
       
    },
    toSell() {
      if (this.num && this.time) {
        this.frm.buytype = 2;
        this.show = false;
        this.showconfirm = true;
        this.title = this.$t("common.buydown");
      } else this.show = true;
    },
    changeTime(index) {
      this.initSelectItems(index);
    },
    initSelectItems(index) {
      this.hy_ykblval = this.hy_ykbl[index]
      this.time = this.timecols[index];
      const tmp = this.hymin[index];
      if(this.hy_price_type == 2){
        this.numcols = [];
        this.numcolstmp.forEach((item) => {
          this.numcols.push((parseFloat(item) * parseFloat(tmp)).toFixed(2));
        });
        this.num = this.numcols[0];
      } else {
        this.numcols =this.hymin
      }
    },
    async getHyConfig() {
      await this.$http({
        method: "post",
        url: "getHyConfig",
      }).then((res) => {
        console.log(res);
        this.numcolstmp = res.data.hy_numcolstmp
        this.hy_price_type = res.data.hy_price_type
        this.unit = res.data.coinname;
        this.balance = res.data.balance;
        this.hy_ykbl = res.data.hy_ykbl;
        this.timecols = res.data.hytime;
        this.hymin = res.data.hymin;
        this.initSelectItems(0);
      });
    },
    async onSubmit() {
      this.frm.m_id = this.safeSymbol.id;
      this.frm.ctime = this.time;
      this.frm.ctzed = this.num;
      await this.$http({
        method: "post",
        url: "creatorder",
        data: this.frm,
      }).then((res) => {
        this.order_id = res.data.order_id;
        this.$toast.success(res.msg);
        const that = this;
        this.showorderconfirm = true;
        this.$nextTick(() => {
          that.$refs.OrderConfirm.getHyOrderInfo();
        });
        this.getHyConfig();
      });
    },
  },
};
</script>
